// packages/web-ui/src/AppShell/TabContentArea.tsx
//
// W2-S2 AC #1 — root region for the tab system. W2-S4 populates with
// `<TabBar />` above `<TabContent />`. The container reserves min-width 640 px
// and exposes `id="main-content"` for the AppShell skip-link target.

import type { JSX, ReactNode } from 'react';
import { PANEL_DEFAULT_WIDTHS, Z_INDEX } from './responsive-tokens.js';
import { TabBar } from './TabBar.js';
import { TabContent } from './TabContent.js';

export interface TabContentAreaProps {
  /** Footer content — the StatusBar is rendered as the last child of this region per AC #1. */
  footer?: ReactNode;
}

export function TabContentArea({ footer }: TabContentAreaProps): JSX.Element {
  return (
    <main
      id="main-content"
      role="main"
      tabIndex={-1}
      aria-label="TESSA Lean main content"
      data-testid="tab-content-area"
      className="bg-cream-50 flex-1 flex flex-col overflow-hidden"
      style={{
        minWidth: PANEL_DEFAULT_WIDTHS.tabContentMin,
        zIndex: Z_INDEX.baseCanvas,
      }}
    >
      <TabBar />
      <div
        className="flex-1 overflow-auto flex flex-col min-h-0"
        style={{ zIndex: Z_INDEX.tabContentScroll }}
      >
        <TabContent />
      </div>
      {footer}
    </main>
  );
}
